import React from 'react'
import type { ListProps as MuiListProps } from '@material-ui/core/List'
import MuiList from '@material-ui/core/List'

export type ListProps = MuiListProps

const List = React.forwardRef<HTMLUListElement, ListProps>(function List(props, ref) {
  return <MuiList ref={ref} {...props} />
})

export default List
